<!-- app-content-header start -->
@if (contentHeader) {
	<div class="content-header row gx-0 my-1">
		<!-- school name -->
		<div class="col-12 text-center text-lg-start">
			@if (currentSchool) {
				<h3 class="mt-1 d-block d-lg-none">{{ currentSchool?.school.name }}</h3>
			}
		</div>
		<!-- Breadcrumb -->
		@if (contentHeader.breadcrumb && contentHeader.breadcrumb.links?.length > 0) {
			<div class="col-12 mb-1 gx-0 breadcrumbs-top d-none d-md-block">
				<app-breadcrumb [breadcrumb]="contentHeader.breadcrumb"></app-breadcrumb>
			</div>
		}
		<div class="col-12 my-1 d-flex justify-content-between align-items-center flex-wrap">
			<div class="d-flex align-items-center">
				<!-- go back button -->
				@if (contentHeader.btn?.visible && contentHeader.btn?.type === 'back') {
					<button class="btn btn-light me-2" (click)="goBack()" [ngbTooltip]="backTooltip" placement="bottom">
						<i class="feather icon-chevron-left"></i>
					</button>
				}
				<!-- header title -->
				<h2 class="content-header-title text-center text-primary m-0">
					@if (contentHeader.icon) {
						<fa-icon [icon]="contentHeader.icon" class="text-primary ms-1"></fa-icon>
					}
					&nbsp;
					{{ contentHeader.headerTitle }}
				</h2>
			</div>
			<!-- create button -->
			@if (canShowCreateButton) {
				<div class="ms-auto">
					@if (contentHeader.btn.disabled) {
						<span ngbTooltip="{{ contentHeader.btn.textDisabled }}">
							<ng-container [ngTemplateOutlet]="button"></ng-container>
						</span>
					} @else {
						<button
							type="button"
							class="btn btn-primary btn-icon btn-lg d-flex"
							[routerLink]="contentHeader.btn.routerLink"
							(click)="onCreate.emit($event)"
							[disabled]="contentHeader.btn.disabled"
							[ngbTooltip]="createTooltip">
							@if (!contentHeader.btn.text) {
								<i class="feather icon-plus"></i>
							}
							@if (contentHeader.btn.text) {
								<span>{{ contentHeader.btn.text }}</span>
							}
						</button>
					}
					<ng-template #button>
						<button
							type="button"
							class="btn btn-primary btn-icon btn-lg d-flex"
							[routerLink]="contentHeader.btn.routerLink"
							(click)="onCreate.emit($event)"
							[disabled]="contentHeader.btn.disabled"
							[ngbTooltip]="createTooltip">
							@if (!contentHeader.btn.text) {
								<i class="feather icon-plus"></i>
							}
							@if (contentHeader.btn.text) {
								<span>{{ contentHeader.btn.text }}</span>
							}
						</button>
					</ng-template>
				</div>
			}
		</div>
		@if (contentHeader.actionButton) {
			<div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none mt-1">
				<div class="form-group breadcrum-right">
					<div ngbDropdown>
						<button ngbDropdownToggle id="dropdownSettings" class="btn-icon btn btn-primary btn-round btn-sm" type="button" rippleEffect>
							<span [data-feather]="'grid'"></span>
						</button>
						<div ngbDropdownMenu aria-labelledby="dropdownSettings">
							<a ngbDropdownItem [routerLink]="['/']"><span [data-feather]="'check-square'" [class]="'mr-50'"></span> Todo</a>
							<a ngbDropdownItem [routerLink]="['/']"><span [data-feather]="'message-square'" [class]="'mr-50'"></span> Chat</a>
							<a ngbDropdownItem [routerLink]="['/']"><span [data-feather]="'mail'" [class]="'mr-50'"></span> Email</a>
							<a ngbDropdownItem [routerLink]="['/']"><span [data-feather]="'calendar'" [class]="'mr-50'"></span> Calendar</a>
						</div>
					</div>
				</div>
			</div>
		}
	</div>
}
<!-- app-content-header end -->
